import getBindingKey from './_getbindingkey.js';
import bindKey from '../../bindnode/_bindkey.js';
import lookForBinder from '../../lookforbinder.js';
import defs from '../../_core/defs.js';
import assign from '../../_helpers/assign.js';
// a binder for instance of Attr
var attributeBinder = {
  setValue: function setValue(value) {
    this.value = value === null || value === undefined ? '' : value;
  }
};
export default function processAttribute(_ref) {
  var _defs$get, _defaultBinder;
  var node = _ref.node,
    attribute = _ref.attribute,
    object = _ref.object,
    eventOptions = _ref.eventOptions;
  var name = attribute.name,
    value = attribute.value;
  // undefined for an element without "type"
  var type = node.type;
  // get a key which will be actually bound to an attribute
  // getBindingKey analyzes given value, creates computable property and returns its key
  var key = getBindingKey({
    object: object,
    text: value
  });
  var probablyValueInput = name === 'value' && type !== 'checkbox' && type !== 'radio';
  var probablyCheckableInput = name === 'checked' && (type === 'checkbox' || type === 'radio');
  var defaultBinder;
  if (probablyValueInput || probablyCheckableInput) {
    defaultBinder = lookForBinder(node);
  }
  // a template other than "{{x}}" is a hidden calc of its own, removed with its binding
  var removeCalc = (_defs$get = defs.get(object)) == null || (_defs$get = _defs$get.props[key]) == null ? void 0 : _defs$get.removeCalc;
  var ownBinder = function ownBinder(binder) {
    return removeCalc ? assign({}, binder, {
      destroy: function destroy(bindingOptions) {
        var _binder$destroy;
        (_binder$destroy = binder.destroy) == null || _binder$destroy.call(this, bindingOptions);
        removeCalc();
      }
    }) : binder;
  };
  // a submit or reset button's binder sets nothing: its value attribute is its label, bound as an attribute
  if ((_defaultBinder = defaultBinder) != null && _defaultBinder.setValue) {
    // if deault binder is found then this is default HTML5 form element
    // remove the attribute and use found binder
    node.removeAttribute(name);
    bindKey(object, key, node, ownBinder(defaultBinder), eventOptions);
  } else {
    // simply bind an attribute
    bindKey(object, key, attribute, ownBinder(attributeBinder), eventOptions);
  }
}